import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CookieService } from 'ngx-cookie-service';

import { AppComponent } from './app.component';
import { SharedModule } from './shared/shared.module';
import { CoreModule } from './core/core.module';
import { AuthGuard } from './core/guards/auth-guard.service';
import { PostLoginFooterComponent } from './shared/layout/postLoginFooter/postLoginFooter.component';
import { AuthModule } from './auth/auth.module';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { TokenInterceptorService } from './core/services/token-interceptor.service';
//import { MatGoogleMapsAutocompleteModule } from '@angular-material-extensions/google-maps-autocomplete';
// import { AgmCoreModule } from '@agm/core';
import { GeolocationBlockerService } from './core/services/geolocation-blocker.service';
import { AppRoutingModule } from './app-routing.module';
import { NgMapsGoogleModule } from '@ng-maps/google';
//import { LoaderComponent } from './shared/loader/loader.component';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { NgxMaskModule } from 'ngx-mask';

import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { faXTwitter } from '@fortawesome/free-brands-svg-icons';
import { ShareService } from 'ngx-sharebuttons';
import { RecaptchaV3Module, RECAPTCHA_V3_SITE_KEY } from 'ng-recaptcha';
import { environment } from '../environments/environment';
@NgModule({
  declarations: [AppComponent, PostLoginFooterComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    SharedModule,
    CoreModule,
    AppRoutingModule,
    AuthModule,
    BsDatepickerModule.forRoot(),
    NgxMaskModule.forRoot(),
    NgMapsGoogleModule.forRoot({
      apiKey: environment.googleMapsApiKey,
      libraries: ['places'],
    }),
    // AgmCoreModule.forRoot(),
    //LoaderComponent,
    RecaptchaV3Module,
  ],
  providers: [
    CookieService,
    AuthGuard,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptorService,
      multi: true,
    },
    GeolocationBlockerService,
    { provide: RECAPTCHA_V3_SITE_KEY, useValue: environment.recaptchaSiteKey },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
  constructor(library: FaIconLibrary, share: ShareService) {
    // ← add ShareService
    library.addIcons(faXTwitter);

    // Global X (Twitter) override — applies to all share buttons in the app
    const twitter = share.prop?.['twitter'];
    if (twitter) {
      twitter.icon = ['fab', 'x-twitter'];
      twitter.text = 'X';
      twitter.color = '#000000';
    }
  }
}
